import { Box } from "@mui/material";
import i18n from "i18n";
import MuiMenuItem from "./MuiMenuItem";

/**
 * Every dropdown starts with a disabled placeholder option (value ""):
 * "Select …" while it has options, "No options available" when it has none.
 * While nothing is chosen, the closed dropdown shows the same text, greyed.
 *
 *   <TextField select value={v} slotProps={{ select: placeholderSelectProps(text) }}>
 *     {placeholderOption(text)}
 *     {options.map(...)}
 *   </TextField>
 */

/** Text of the placeholder option */
export const placeholderText = ({ placeholder, hasOptions = true } = {}) =>
  hasOptions ? placeholder || i18n.t("form:select") : i18n.t("common:noOptions");

/** "Select <name>" (e.g. "Select Role") */
export const selectText = (name) =>
  name ? i18n.t("common:selectItem", { item: name }) : i18n.t("form:select");

/** True while nothing is chosen */
export const isEmptyValue = (value) =>
  value === "" || value == null || (Array.isArray(value) && value.length === 0);

/** The first, disabled option */
export const placeholderOption = (text) => (
  <MuiMenuItem key="__placeholder" value="" disabled>
    <em>{text}</em>
  </MuiMenuItem>
);

/** Shows the placeholder (greyed) in the closed dropdown while nothing is chosen */
export const placeholderRenderValue =
  (text, getLabel = (value) => value) =>
  (value) =>
    isEmptyValue(value) ? (
      <Box component="span" sx={{ color: "text.disabled" }}>
        {text}
      </Box>
    ) : (
      getLabel(value)
    );

/** Select props for a MUI TextField with `select` */
export const placeholderSelectProps = (text, getLabel) => ({
  displayEmpty: true,
  renderValue: placeholderRenderValue(text, getLabel),
});
